import React, { useEffect, useState } from 'react';

const LinkedInIcon: React.FC<{ className?: string }> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const GitHubIcon: React.FC<{ className?: string }> = ({ className = 'w-6 h-6' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 .5C5.65.5.5 5.66.5 12.03c0 5.1 3.3 9.41 7.88 10.94.58.1.79-.25.79-.56l-.01-1.99c-3.2.7-3.88-1.38-3.88-1.38-.53-1.34-1.28-1.7-1.28-1.7-1.05-.71.08-.7.08-.7 1.16.08 1.77 1.2 1.77 1.2 1.03 1.78 2.71 1.26 3.37.97.1-.76.4-1.26.73-1.55-2.56-.29-5.25-1.29-5.25-5.74 0-1.27.45-2.31 1.19-3.12-.12-.29-.52-1.46.11-3.04 0 0 .98-.32 3.2 1.19a11.04 11.04 0 0 1 5.82 0c2.22-1.51 3.19-1.19 3.19-1.19.64 1.58.24 2.75.12 3.04.74.81 1.19 1.85 1.19 3.12 0 4.46-2.69 5.45-5.26 5.73.41.35.78 1.04.78 2.09l-.01 3.1c0 .31.21.67.8.56A11.54 11.54 0 0 0 23.5 12.03C23.5 5.66 18.35.5 12 .5z" />
  </svg>
);

const Contact: React.FC = () => {
  const fullConnectTitle = "Let's Connect";
  const [connectTitle, setConnectTitle] = useState('');

  useEffect(() => {
    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      currentIndex += 1;
      setConnectTitle(fullConnectTitle.slice(0, currentIndex));

      if (currentIndex === fullConnectTitle.length) {
        clearInterval(typingInterval);
      }
    }, 120);

    return () => clearInterval(typingInterval);
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    setTimeout(() => {
      setIsSubmitting(false);
      alert('Thank you for your message! I\'ll get back to you soon.');
      setFormData({ name: '', email: '', message: '' });
    }, 2000);
  };

  const inputClass =
    'w-full px-4 py-3 border border-gray-200 rounded-xl bg-white text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-soft-pink/40 focus:border-soft-pink transition-colors';

  const labelClass = 'block text-sm font-medium text-gray-900 mb-2';

  return (
    <div className="pt-16 min-h-screen bg-[#F8FAFB]">
      <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 xl:gap-24 items-start">
            {/* Intro + contact details */}
            <div>
              <h1 className="text-4xl md:text-5xl font-clean font-semibold text-soft-pink tracking-tight mb-6">
                {connectTitle}
                {connectTitle.length < fullConnectTitle.length && (
                  <span className="text-soft-pink animate-pulse">|</span>
                )}
              </h1>
              <p className="text-gray-900 text-base md:text-lg leading-relaxed mb-10 max-w-md">
                I&apos;d love to hear from you! Whether you have a project in mind, want to collaborate,
                or just want to say hello, feel free to reach out. Let&apos;s make something amazing together!
              </p>

              <ul className="space-y-5">
                <li className="flex items-start gap-4">
                  <span className="material-icons text-soft-pink text-2xl shrink-0 mt-0.5" aria-hidden="true">
                    location_on
                  </span>
                  <span className="text-gray-900 pt-0.5">Sydney, Australia</span>
                </li>
                <li>
                  <a
                    href="mailto:pnair9090@gmail.com"
                    className="flex items-start gap-4 group"
                  >
                    <span className="material-icons text-soft-pink text-2xl shrink-0 mt-0.5" aria-hidden="true">
                      email
                    </span>
                    <span className="text-gray-900 pt-0.5 group-hover:text-soft-pink transition-colors">
                      pnair9090@gmail.com
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://linkedin.com/in/priyanair9"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-4 group text-soft-pink"
                  >
                    <span className="shrink-0 mt-0.5" aria-hidden="true">
                      <LinkedInIcon className="w-6 h-6" />
                    </span>
                    <span className="text-gray-900 pt-0.5 group-hover:text-soft-pink transition-colors">
                      linkedin.com/in/priyanair9
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/priyanair9"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-4 group text-soft-pink"
                  >
                    <span className="shrink-0 mt-0.5" aria-hidden="true">
                      <GitHubIcon className="w-6 h-6" />
                    </span>
                    <span className="text-gray-900 pt-0.5 group-hover:text-soft-pink transition-colors">
                      github.com/priyanair9
                    </span>
                  </a>
                </li>
              </ul>
            </div>

            {/* Form card */}
            <div className="bg-white rounded-2xl shadow-softer p-8 md:p-10 border border-gray-100/80">
              <h2 className="text-2xl md:text-3xl font-clean font-semibold text-soft-pink mb-8">
                Send Me a message
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className={labelClass}>
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className={inputClass}
                    placeholder="Your name"
                  />
                </div>

                <div>
                  <label htmlFor="email" className={labelClass}>
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className={inputClass}
                    placeholder="example@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="message" className={labelClass}>
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={5}
                    className={`${inputClass} resize-none`}
                    placeholder="Type your message"
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full btn-primary py-3.5 rounded-xl font-medium disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
